import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navigation-section',
  templateUrl: './navigation-section.component.html',
  styleUrls: ['./navigation-section.component.css']
})
export class NavigationSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
